// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  console.log("@@@ purchase = ", params);
  ///////////////////////////////
  // START GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////

  // initialization
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  // config
  gtag("config", "AW-17009293754");

   // sending `purchase` event to Google ads and Google merchant center
  gtag("event", "purchase", {
    send_to: [
      "AW-17009293754/T4Y4CKnWq7cbELrz1K4_",
      "AW-17009293754/uADPCLGuirkaELrz1K4_"
    ],
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_purchase",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });
  

    // config 28th Nov 2025
  gtag("config", "AW-10849848868");
  // sending `conversion` event to Google Ads
  gtag("event", "conversion", {
    send_to: "AW-10849848868/qJ-XCK7CzpoDEKSczrUo",
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    breeze_event_type: "breeze_conversion",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });

  // // sending remarketing `page_view` events
  // gtag("event", "page_view", {
  //   send_to: "AW-10849848868",
  //   ecomm_pagetype: "purchase",
  //   ecomm_totalvalue: params.totalPrice,
  //   breeze_event_type: "breeze_page_view",
  //   breeze_event_send_to: ["AW"],
  //   breeze_event_time: new Date().toISOString(),
  // });

  // sending `page_view` event to Google ads and Google merchant center (Note: Also sending to GA4 since `page_views` are not send in GA4 integration)
  // gtag("event", "page_view", {
  //   send_to: [
  //     "G-X381V1JVPL",
  //     "AW-10849848868/qJ-XCK7CzpoDEKSczrUo",
  //   ],
  //   page_title: getGAOrderCompleteTitle(),
  //   page_location: getCurrentPageUrl(),
  //   ignore_referrer: "true",
  //   breeze_event_type: "breeze_page_view",
  //   breeze_event_send_to: ["G", "AW"], // G -> Google analytics, AW -> Google ads, MC -> Google merchant center
  //   breeze_event_time: new Date().toISOString(),
  // });

 



  ///////////////////////////////
  // END GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////

  ///////////////////////////////
  // START GOOGLE ANALYTICS CODE
  ///////////////////////////////

  // config
  // gtag("config", "<GOOGLE_ADS_ID_OF_OTHER_ACCOUNT>");

  // // sending `complete order` event to Google analytics
  // gtag("event", "Completed Order", {
  //   currency: params.currency,
  //   language: getLanguage(),
  //   page_title: getGAOrderCompleteTitle(),
  //   screen_resolution: getScreenResolution(),
  //   client_id: getGAClientIDfromMeasurementID(),
  //   event_category: "EnhancedEcommerce",
  //   allow_display_features: true,
  //   allow_ad_personalization_signals: true,
  //   cookie_domain: getMerchantDomain(),
  //   cookie_flags: "",
  //   cookie_path: "/",
  //   send_to: ["G-CF87ZLX6WG"],
  //   breeze_event_type: "breeze_complete_order",
  //   breeze_event_send_to: ["G"],
  //   breeze_event_time: new Date().toISOString(),
  // });

  // // sending `page_view` event to GA4
  // gtag("event", "page_view", {
  //   event_category: "All",
  //   value: params.totalPrice,
  //   send_to: "G-CF87ZLX6WG",
  //   breeze_event_type: "breeze_page_view",
  //   breeze_event_send_to: ["G"],
  //   breeze_event_time: new Date().toISOString(),
  // });

  ///////////////////////////////
  // END GOOGLE ANALYTICS CODE
  ///////////////////////////////

  // AFFILIATE
  let utm_source = getCookie("vc-source");
  let saleAmount = (typeof params !== "undefined" && params.totalPrice) || "";
  let txnId = (typeof params !== "undefined" && params.shopOrderId) || "";
  let txnIdClean = txnId.toString().replace("#", "");

  if (utm_source !== undefined && utm_source === "vCommission") {
    console.log("vCommission tracking initiated");

    // Construct URL with ampersands (they will NOT be escaped in JS)
    let trackingUrl =
      "https://track.vcommission.com/pixel?av=684a703b6bb9654e6257d984&sale_amount=" +
      saleAmount +
      "&txn_id=" +
      txnIdClean +
      "&sub1=" +
      txnIdClean +
      "&sub2=payu";

    let iframe = document.createElement("iframe");
    iframe.src = trackingUrl;
    iframe.scrolling = "no";
    iframe.frameBorder = "0";
    iframe.width = "1";
    iframe.height = "1";

    setTimeout(() => {
      document.body.appendChild(iframe);
      console.log("vCommission tracking iframe inserted");
    }, 1000);
  }
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
    console.log("@@@ add payment info = ",params);
  ///////////////////////////////
  // START GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////

  // initialization
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  // config
  gtag("config", "17009293754");

  // sending `page_view` event to Google ads and Google merchant center (Note: Also sending to GA4 since `page_views` are not send in GA4 integration)
  gtag("event", "page_view", {
    send_to: [
      "G-CF87ZLX6WG",
      "AW-17009293754/P91ECJmToKccELrz1K4_",
      "MC-DKN61BTWL3",
    ],
    page_title: getGAOrderCompleteTitle(),
    page_location: getCurrentPageUrl(),
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_send_to: ["G", "AW", "MC"],
    breeze_event_time: new Date().toISOString(),
  });

  ///////////////////////////////
  // END GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////

  ///////////////////////////////
  // START GOOGLE ANALYTICS CODE
  ///////////////////////////////

  gtag("event", "add_payment_info", {
    send_to: ["AW-17009293754/P91ECJmToKccELrz1K4_"],
    currency: params.totalPrice,
    total: params.itemCount,
    ignore_referrer: "true",
    breeze_event_type: "breeze_add_payment_info",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });

  ///////////////////////////////
  // END GOOGLE ANALYTICS CODE
  ///////////////////////////////
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

 
// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  console.log("@@@ begin checkout = ",params);
  ///////////////////////////////
  // START GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////

  // initialization
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  // config
  gtag("config", "17009293754");

  // sending `page_view` event to Google ads and Google merchant center (Note: Also sending to GA4 since `page_views` are not send in GA4 integration)
  gtag("event", "page_view", {
    send_to: [
      "G-CF87ZLX6WG",
      "MC-DKN61BTWL3",
      "AW-17009293754/cH4cCP7qhPAbELrz1K4_",
      "AW-17009293754/gLYECNm1irkaELrz1K4_"

    ],
    page_title: getGAOrderCompleteTitle(),
    page_location: getCurrentPageUrl(),
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_send_to: ["G", "AW", "MC"],
    breeze_event_time: new Date().toISOString(),
  });

  // sending `begin_checkout` event to Google Ads
  gtag("event", "begin_checkout", {
    send_to: ["AW-17009293754/cH4cCP7qhPAbELrz1K4_", "AW-17009293754/gLYECNm1irkaELrz1K4_"],
    ecomm_totalvalue: params.totalPrice,
    value: params.totalPrice,
    currency: params.currency,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_checkout_initiated",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });

  ///////////////////////////////
  // END GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------

// ----------------- Common Helper Functions ----------------------------------

// function to get the screen resolution in particular format (i.e. '2560x1440')
function getScreenResolution() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  return screenHeight + "x" + screenWidth;
}

// function to return language used in GA config (i.e. "en-gb", "en-us")
function getLanguage() {
  return "en-gb";
}

// function to return order complete page title
function getGAOrderCompleteTitle() {
  return "Breeze Checkout Thank You Page";
}

// function to return GA clientId if present or
function getGAClientIDfromMeasurementID() {
  try {
    var match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)"),
      raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
      match = raw.match(/(\d+\.\d+)$/);
    }
    return match ? match[1] : null;
  } catch (e) {
    console.log("Exception: unable to get GA clientId");
  }
  return null;
}

// function to return merchants domain
function getMerchantDomain() {
  try {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split(".");
    const tld = domainParts.slice(-2).join(".");
    return tld;
  } catch {
    console.log("Exception: unable to get merchant domain");
  }
  return null;
}

// function to return current page url
function getCurrentPageUrl() {
  return window.location.href;
}

// function to return converted cart items
function getConvertedItems(items) {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
    };
  });
}

// ----------------- Common Helper Functions ----------------------------------
// AFFILIATE
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
